import { useState, useEffect, type Dispatch, type SetStateAction } from 'react';
import { Divider, ListBox } from '@workramp/ui';
import { useActionCable } from '~/providers';
import { createAIAnswer } from '../../api';
import { LearnerAIQuestionAnswer } from './LearnerAIQuestionAnswer';

interface AnswerWrapperProps {
  question?: string;
  userId: number;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  answer?: string;
  setAnswer: Dispatch<SetStateAction<string | null>>;
}

export const LearnerAIQuestionAnswerWrapper = ({
  question,
  userId,
  loading,
  setLoading,
  answer,
  setAnswer,
}: AnswerWrapperProps) => {
  const [content, setContent] = useState([]);

  const consumer = useActionCable();

  useEffect(() => {
    if (!question) return;

    createAIAnswer(question);
  }, [question, setLoading, setAnswer]);

  useEffect(() => {
    const subscription = consumer.subscriptions.create(
      {
        channel: 'LearnerSearchAnswers::QuestionAnswerChannel',
        user_id: userId,
      },
      {
        received: (resp) => {
          const { answer: newAnswer, answered, question: answeredQuestion, courses, resources } = resp;

          // we could be getting pinged with an answer to a different question than the one currently in the search bar, so skip that
          if (answeredQuestion !== question) return;

          setLoading(false);
          setAnswer(answered ? newAnswer : null);
          setContent([
            ...courses.map((c) => ({ ...c, content_type: 'guide' })),
            ...resources.map((r) => ({ ...r, content_type: 'resource' })),
          ]);
        },
      },
    );

    return () => {
      subscription?.unsubscribe();
    };
  }, [question, userId, setLoading, setAnswer, consumer]);

  return (
    <ListBox.Item key="ai" textValue="">
      {/* TODO this is a hack to get the skeleton to expand to the full search but we should figure out why it doesn't automatically */}
      <div style={{ width: '550px' }}>
        <LearnerAIQuestionAnswer loading={loading} answer={answer} content={content} variant="dropdown" />
        <Divider />
      </div>
    </ListBox.Item>
  );
};
